module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo7-81a46e1d40daabad3a6b0753aa960a42.jpg";